if (!customElements.get('featured-product-info-manuly')) {
  customElements.define(
    'featured-product-info-manuly',
    class FeaturedProductInfoManuly extends ProductInfoManuly {

        constructor() {
            super();

            subscribe(PUB_SUB_EVENTS.variantChange,(event) =>{
                this.changeImages(event, );
            });
        }

        changeImages(event) {
            let elementNodeListOf = document.querySelectorAll('#CoverMaterialFeaturedProduct');
            for (var i = 0; i < elementNodeListOf.length; i++) {
                elementNodeListOf[i].setAttribute('src', featuredProdOptions[event.data.variant.option3]);
            }
            elementNodeListOf = document.querySelectorAll('#CoverSizeFeaturedProduct');
            for (var i = 0; i < elementNodeListOf.length; i++) {
                elementNodeListOf[i].setAttribute('src', featuredProdOptions[event.data.variant.option1]);
            }
        }

        changePictures({ data: { event, target, selectedOptionValues } }){
            console.log(target);
        }


        getSelectedVariant(productInfoNode) {
            const selectedVariant = productInfoNode.querySelector('featured-variant-selects-manuly [data-selected-variant]')?.innerHTML;
            return !!selectedVariant ? JSON.parse(selectedVariant) : null;
        }

        findMediaFields(html) {
            const mediaGallerySource = this.querySelector('media-gallery ul');
            const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
            return {mediaGallerySource, mediaGalleryDestination};
        }

        handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "featured-product-info-manuly[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('featured-product-info-manuly'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }
    }
  );
}
